import { compact } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TextKey, RouteName } from '@mews-commander/enums';
import {
    hasCurrentEnterpriseServiceId,
    getCurrentEnterpriseChainId,
} from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { areCurrentEnterpriseCustomerStatisticsEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import {
    isCurrentProfileEnabledToManageCustomers,
    isCurrentProfileEnabledToManageCompanies,
    canCurrentProfileManageTravelAgencies,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getSimpleSearchResult } from './getSimpleSearchResult';
import { SearchResult } from './types';

export default createSelector(
    getCurrentEnterpriseChainId,
    isCurrentProfileEnabledToManageCustomers,
    areCurrentEnterpriseCustomerStatisticsEnabled,
    hasCurrentEnterpriseServiceId,
    isCurrentProfileEnabledToManageCompanies,
    canCurrentProfileManageTravelAgencies,
    (
        chainId: string,
        isCustomerManager: boolean,
        customerStatisticsEnabled: boolean,
        hasReservableService: boolean,
        isCompaniesManager: boolean,
        isTravelAgeneciesManager: boolean
    ) =>
        compact<SearchResult>([
            isCustomerManager
                ? getSimpleSearchResult({
                      routeName: RouteName.CustomerCreate,
                      titleKey: TextKey.Customer,
                      params: { query: { RedirectToProfile: 'true', ChainId: chainId } },
                  })
                : null,
            isCustomerManager && customerStatisticsEnabled
                ? getSimpleSearchResult({
                      routeName: RouteName.CustomerStatisticReportIndex,
                      titleKey: TextKey.CustomerStatisticReport,
                  })
                : null,
            isCustomerManager && hasReservableService
                ? getSimpleSearchResult({
                      routeName: RouteName.CustomerProfileReportIndex,
                      titleKey: TextKey.CustomerProfileReport,
                  })
                : null,
            isCompaniesManager
                ? getSimpleSearchResult({
                      routeName: RouteName.CompanyReportIndex,
                      titleKey: TextKey.CompanyPlural,
                  })
                : null,
            isTravelAgeneciesManager && hasReservableService
                ? getSimpleSearchResult({
                      routeName: RouteName.TravelAgencyContractReportIndex,
                      titleKey: TextKey.TravelAgencyContractPlural,
                  })
                : null,
            hasReservableService && isCustomerManager
                ? getSimpleSearchResult({
                      routeName: RouteName.TimeSpentReportIndex,
                      titleKey: TextKey.TimeSpentReport,
                  })
                : null,
        ])
);
